export const emptyLengthCheck = (value: string) => {
  if (value.length === 0) {
    return true;
  }
  return false;
};

export const minimumLengthCheck = (value: string, minimumValue: number) => {
  if (value.length < minimumValue) {
    return true;
  }
  return false;
};

export const lowerCaseCheck = (value: string) => {
  if (!value.match(/[a-z]/g)) {
    return true;
  }
  return false;
};

export const upperCaseCheck = (value: string) => {
  if (!value.match(/[A-Z]/g)) {
    return true;
  }
  return false;
};

export const specialCharCheck = (value: string) => {
  // eslint-disable-next-line no-useless-escape
  if (!value.match(/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/)) {
    return true;
  }
  return false;
};

export const includeNumberCheck = (value: string) => {
  if (!value.match(/\d/g)) {
    return true;
  }
  return false;
};

export const includeFirstNameLastNameCheck = (value: string, userName: any) => {
  if (value.includes(userName)) {
    return true;
  }
  return false;
};
